import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import "../Styles/Layout.css";

function Layout() {
  return (
    <>
      <Navbar />
      <main id="main" className="appMain">
        <Outlet />
      </main>
    </>
  );
}

export default Layout;
